import { ProductCatalogApiClient } from '@fourthwall/services/dist/ProductCatalogApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useProductsQuery = createQueryHook(ProductCatalogApiClient.getProducts, {
  queryKey: ['products'],
})
